import HubsShow from "../components/hubs/Show";

export default [
  { name: 'Hubs', path: '/hubs', component: HubsShow,  }
]